import { render, staticRenderFns } from "./ModalChecksBillComponent.vue?vue&type=template&id=16cd70d2"
import script from "./ModalChecksBillComponent.vue?vue&type=script&lang=js"
export * from "./ModalChecksBillComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports